import styled from "styled-components";

export const Categories = styled.div`
  display: flex;
  width: 100%;
`;
